
export default {
    name: 'historique-hypothese-diagnostique',
    components: {},
    props: {
        historique: Object
    },
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}


